import { box } from "./importShared";

export function StepMapping({ analysis, mapping, setMapping }) {
  const cols = analysis.schema || [];
  const used = new Set(Object.values(mapping).filter(Boolean));
  const phoneOk = Object.values(mapping).includes("phone");
  return (
    <div className="space-y-3" data-testid="import-step-mapping">
      <p className="text-xs text-slate-400">Colonne riconosciute automaticamente dal modello <span className="font-mono2 text-slate-500">{analysis.template_version}</span>. Correggi le associazioni se il file ha intestazioni diverse; una colonna non associata viene ignorata.</p>
      {!phoneOk && <p className="text-xs text-red-400" data-testid="import-mapping-phone-missing">Associa una colonna al campo <b>Telefono</b> per continuare.</p>}
      <div className={`${box} overflow-hidden`}>
        <div className="max-h-[50vh] overflow-y-auto">
          <table className="w-full text-xs">
            <thead className="bg-[#0A0E17] text-slate-400 sticky top-0"><tr><th className="text-left px-3 py-2">Colonna nel file</th><th className="text-left px-3 py-2">Esempio</th><th className="text-left px-3 py-2">Campo Rubrica</th></tr></thead>
            <tbody>
              {analysis.headers.map((h, i) => (
                <tr key={h} className="border-t border-[#1F2937]/60" data-testid={`import-map-row-${i}`}>
                  <td className="px-3 py-1.5 text-slate-200 font-medium">{h}</td>
                  <td className="px-3 py-1.5 text-slate-500 font-mono2 truncate max-w-[140px]">{analysis.sample?.[0]?.[h] || "—"}</td>
                  <td className="px-3 py-1.5">
                    <select data-testid={`import-map-select-${i}`} value={mapping[h] || ""} onChange={(e) => setMapping({ ...mapping, [h]: e.target.value })}
                            className={`w-full bg-[#111827] border rounded-md h-8 px-2 text-xs ${mapping[h] ? "border-[#10B981]/40 text-slate-100" : "border-[#1F2937] text-slate-500"}`}>
                      <option value="">— ignora —</option>
                      {cols.map((c) => <option key={c.key} value={c.key} disabled={used.has(c.key) && mapping[h] !== c.key}>{c.label}{c.required ? " *" : ""}</option>)}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
